import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import YearInReview, { markYearInReviewSeen, yearInReviewSeen } from "./YearInReview";
import { useProgress } from "../context/ProgressContext";
import { lessonDayStatus } from "../lib/lessonDay";

// Auto-plays the year-in-review once per child on their first lesson day in January (server-backed children only).
const YearInReviewWatcher = () => {
  const { activeChild } = useProgress();
  const { pathname, search } = useLocation();
  const [closed, setClosed] = useState(null);
  const now = new Date();
  const year = now.getFullYear() - 1;
  const forced = new URLSearchParams(search).get("yir") === "1";
  if (!activeChild?.ownerId || activeChild.readOnly) return null;
  if (pathname.startsWith("/report-card")) return null;
  const ld = lessonDayStatus(activeChild.lessonDay, activeChild.activity || []);
  const due = forced || (now.getMonth() === 0 && !!ld?.isToday);
  if (!due || closed === activeChild.id || (!forced && yearInReviewSeen(activeChild.id, year))) return null;
  const close = () => { markYearInReviewSeen(activeChild.id, year); setClosed(activeChild.id); };
  return <YearInReview childId={activeChild.id} year={year} onClose={close} />;
};

export default YearInReviewWatcher;
